// Angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// App - Common
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { Settings, SettingsService, settingsServiceFactory } from './settings';
import { LocalStoreManager } from './shared/services/local-store-manager.service';
import { AppRoutingModule } from './routing/app-routing.module';
import { HomeComponent } from './home/home.component';
import { AuthModule } from './core/auth';
import { CoreModule } from './core/core.module';
import { CountryFlagComponent } from './shared/components/country-flag/country-flag.component';
import { ReportFilterModule } from './report-filters/report-filters.module';
import { SharedModule } from './shared/shared.module';

// App - Specific
import { SidebarComponent } from './sidebar/sidebar.component';

// Third Party
import { TranslatesModule } from './modules/translate/translates.module'
import { BootstrapModule } from './modules/bootstrap/bootstrap.module'
import { ToastrModule } from 'ngx-toastr';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
//import { AngularStickyThingsModule } from '@w11k/angular-sticky-things';

import { WindowRef, _window } from './shared/services/window.token';

import { StickyHeaderDirective } from './shared/layout/header/sticky-header.directive';
import { DecimalPipe } from '@angular/common';

import { DerivativeSearchService } from './core/data/derivative-search.service';
import { DerivativeSearchToken, SimilarSearchToken } from 'vehicle-search';

const DIRECTIVES = [StickyHeaderDirective, StickyHeaderDirective];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    SidebarComponent,
    //GroupByPipe,
    ...DIRECTIVES,
    CountryFlagComponent,
  ],

  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    SharedModule,
    HttpClientModule, // import HttpClientModule after BrowserModule
    LoadingModule.forRoot({
      fullScreenBackdrop: true,
      animationType: ANIMATION_TYPES.circle,
      primaryColour: '#e56c0c',

      backdropBorderRadius: '4px'
    }),
    ToastrModule.forRoot(),
    AuthModule.forRoot(),
    TranslatesModule,
    BootstrapModule, ReportFilterModule
    //AngularStickyThingsModule,
  ],

  //every provider registered within an NgModule will be accessible in the entire application.
  //a provider registered in an application component is available only on that component and all its children.
  providers: [
    //https://juristr.com/blog/2018/01/ng-app-runtime-config/
    { provide: APP_INITIALIZER, useFactory: settingsServiceFactory, deps: [SettingsService, LocalStoreManager, Settings, HttpClient], multi: true },
    Settings,
    { provide: WindowRef, useFactory: _window },
    { provide: DerivativeSearchToken, useClass: DerivativeSearchService/*, deps: [HttpClient, LoginService]*/ },
    { provide: SimilarSearchToken, useExisting: DerivativeSearchService },
    DecimalPipe
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
